const shifts = [
  {
    before: '"Why do I crash when I tried so hard?"',
    after: '"What hidden drains or danger signals is my system trying to protect me from?"',
  },
  {
    before: '"How do I fix my inconsistency?"',
    after: '"How do I offer my nervous system enough safety to let change become possible?"',
  },
];

export default function DifferenceAndCTA() {
  return (
    <section className="relative overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          alt="Soft airy botanical background"
          className="w-full h-full object-cover"
          src="https://readdy.ai/api/search-image?query=Very%20soft%20pale%20white%20and%20light%20gray%20background%20with%20delicate%20airy%20eucalyptus%20leaves%20and%20fern%20branches%2C%20minimalist%20botanical%20composition%2C%20subtle%20watercolor%20style%2C%20gentle%20diffused%20light%2C%20calming%20wellness%20aesthetic%2C%20muted%20sage%20and%20soft%20silver%20tones%2C%20editorial%20photography%2C%20serene%20peaceful%20atmosphere&width=1600&height=900&seq=course-diff-01&orientation=landscape"
        />
        <div className="absolute inset-0 bg-white/75" />
      </div>

      <div className="relative z-10 section-padding max-w-6xl mx-auto">
        {/* What Makes This Different */}
        <div className="max-w-3xl mx-auto mb-16">
          <div className="bg-[#6B8FA3]/90 backdrop-blur-sm border border-[#5A7F94]/40 rounded-xl p-7 md:p-10 shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
            <div className="flex items-center gap-2 mb-5">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/15">
                <i className="ri-lightbulb-line text-white" />
              </span>
              <h2 className="font-heading text-xl font-bold text-white">What Makes This Different</h2>
            </div>
            <p className="text-sm text-white/80 leading-relaxed mb-6">
              The Energy Safe Journey combines <strong className="text-white">lived experience</strong> with <strong className="text-white">science-informed principles</strong> to create a practical system that works in everyday life. Drawing on concepts such as nervous system regulation, behavioural science, energy management, and coaching psychology, it transforms abstract advice into clear, step-by-step tools.
            </p>

            <h3 className="font-heading text-base font-semibold text-white mb-4">The Shift</h3>
            <div className="space-y-4">
              {shifts.map((s, i) => (
                <div key={i} className="grid sm:grid-cols-[1fr_auto_1fr] gap-3 items-center">
                  <div className="bg-[#A4BCC4]/80 border border-[#8DAAB5]/30 rounded-lg px-4 py-3 text-center sm:text-left shadow-sm">
                    <p className="text-sm text-[#2C3E6B] line-through">{s.before}</p>
                  </div>
                  <div className="flex justify-center">
                    <span className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 text-white">
                      <i className="ri-arrow-right-line text-sm" />
                    </span>
                  </div>
                  <div className="bg-[#6B8FA3] border border-white/20 rounded-lg px-4 py-3 text-center sm:text-left shadow-md">
                    <p className="text-sm text-white font-medium">{s.after}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Price & CTA */}
        <div className="max-w-lg mx-auto text-center">
          <div className="bg-[#6B8FA3]/90 backdrop-blur-sm border border-[#5A7F94]/40 rounded-2xl p-8 md:p-10 shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all duration-300">
            <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase bg-white/15 text-white rounded-full mb-4 border border-white/20">
              Special Launch Price
            </span>

            <div className="flex items-baseline justify-center gap-3 mb-2">
              <span className="text-2xl text-white/40 line-through">£197</span>
              <span className="text-5xl font-bold text-white">£97</span>
            </div>

            <p className="text-sm text-white/70 mb-6">
              One-time payment. Lifetime access to all 5 Energy Paths + downloadable tools.
            </p>

            <ul className="text-left space-y-2.5 mb-8 max-w-sm mx-auto">
              <li className="flex items-start gap-2 text-sm text-white/80">
                <span className="mt-0.5 w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-sm text-white/70" />
                </span>
                <span>5 comprehensive Energy Paths</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/80">
                <span className="mt-0.5 w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-sm text-white/70" />
                </span>
                <span>5 downloadable PDF tools &amp; trackers</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/80">
                <span className="mt-0.5 w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-sm text-white/70" />
                </span>
                <span>Self-paced, lifetime access</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-white/80">
                <span className="mt-0.5 w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-sm text-white/70" />
                </span>
                <span>Science-informed, lived-experience backed</span>
              </li>
            </ul>

            <a
              href="https://federica-tedeschi3.systeme.io/course"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 w-full bg-[#2C3E6B] text-white px-8 py-4 rounded-lg font-semibold text-base shadow-lg hover:bg-[#243A5C] hover:scale-[1.03] hover:-translate-y-[3px] hover:shadow-xl transition-all duration-300 ease-out whitespace-nowrap cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-shopping-cart-line text-base" />
              </span>
              Enrol Now — £97
            </a>

            <p className="text-xs text-white/50 mt-4">
              Secure checkout powered by Systeme.io
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}